/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { EditorContext } from "../../Context/EditorContext";
import { useOutsideAlerter } from "../GlobalComponents/HandleClick";
import Modal from "../GlobalComponents/Modal";
import Row from "../GlobalComponents/Row";
import Button from "../GlobalComponents/Button";

const RightMenu = () => {
  const {
    handleSave,
    activeView,
    setActiveView,
    isOpened,
    setIsOpened,
    isSaved,
    isSettings,
    setIsSettings,
    settingsRef,
    viewRef,
    handleSettings,
    title,
    setTitle,
    name,
    setName,
    handleNewPen,
    hiddenMenu,
  } = useContext(EditorContext);

  useOutsideAlerter(settingsRef, () => setIsSettings(false));
  useOutsideAlerter(viewRef, () => setIsOpened(false));

  return (
    <div css={styles} className={(hiddenMenu ? "hidden" : "") + " rightMenu"}>
      <div className="wrapper">
        <Button
          btnText="Settings"
          hidden={!isSettings}
          setHidden={setIsSettings}
        />
        {isSettings && (
          <Modal closeModal={settingsRef}>
            <Row
              settingsName="Title"
              inputExists={true}
              val={title}
              setVal={setTitle}
              bg="#30364c"
            />
            <Row
              settingsName="Publisher"
              inputExists={true}
              val={name}
              setVal={setName}
              bg="#30364c"
            />
            <Row
              settingsName="Editor layout"
              layoutExists={true}
              bg="#30364c"
            />
            <div className="buttonWrapper">
              <button onClick={handleSettings} className="btn settingsBtn">
                Save
              </button>
            </div>
          </Modal>
        )}
      </div>
      <div className="wrapper">
        <Button
          btnText="Change View"
          hidden={!isOpened}
          setHidden={setIsOpened}
        />
        {isOpened && (
          <Modal closeModal={viewRef}>
            <Row
              setIsOpened={setIsOpened}
              activeView={activeView}
              setActiveView={setActiveView}
              viewName="Editor View"
              cursorExists={true}
            />
            <Row
              setIsOpened={setIsOpened}
              activeView={activeView}
              setActiveView={setActiveView}
              viewName="Full Page View"
              cursorExists={true}
            />
          </Modal>
        )}
      </div>
      <button onClick={handleNewPen} className="btn newPen">
        New Pen
      </button>
      <button className="btn saveBtn" onClick={handleSave}>
        {isSaved ? "Saved" : "Save File"}
      </button>
    </div>
  );
};

const styles = css`
  display: flex;
  .wrapper {
    position: relative;
  }
  .btn {
    border: none;
    outline: none;
    background: #4e5369;
    color: #fff;
    width: 120px;
    padding: 12px;
    margin-left: 14px;
    cursor: pointer;
    transition: background 400ms ease-in-out;
    &:hover {
      background: #3a3e4c;
    }
  }
  .buttonWrapper {
    width: 100%;
    padding: 0 14px 14px 14px;
    display: flex;
    justify-content: flex-end;
    background: #30364c;
    .btn {
      width: 128px;
      margin-left: 0;
      transition: background 500ms ease-in-out;
      &:hover {
        background: #1d1e22;
      }
    }
  }
  @media (max-width: 810px) {
    position: absolute;
    top: 0;
    left: 0;
    background: #212431;
    min-height: 100vh;
    width: 100%;
    padding: 20px 0;
    max-width: 380px;
    flex-direction: column;
    align-items: center;
    transition: left 700ms ease-in-out;
    &.hidden {
      left: -600px;
    }
    .btn {
      width: 320px;
      margin: 10px 0 0 0;
      margin-left: 0;
      padding: 16px 0;
    }
  }
`;

export default RightMenu;
